import { Action } from 'redux';
import { ErrorAction } from '@sofology/sofologycomponents';
import { put, select } from 'redux-saga/effects';

import { CheckoutActionTypes, CheckoutActions } from '../../checkout.types';
import { ACTION_CREATOR_NAME, errorToBasketErrorModel } from 'helpers';
import { BasketSagaReturnType } from 'store/sagaHelpers';
import { AppState } from 'store';

export interface SaveIfcFinanceDataAction extends Action<CheckoutActionTypes.SAVE_IFC_FINANCE_DATA> {
    ifcApplicationData: any;
    isLastApplicationStep: boolean;
}

export interface SaveIfcFinanceDataActionStart extends Action<CheckoutActionTypes.SAVE_IFC_FINANCE_DATA_START> {
}

export interface SaveIfcFinanceDataActionSuccess extends Action<CheckoutActionTypes.SAVE_IFC_FINANCE_DATA_SUCCESS> {
    ifcApplicationData: any;
    ifcApplicationFilledByCustomer: boolean;
}

export interface SaveIfcFinanceDataActionError extends ErrorAction<CheckoutActionTypes.SAVE_IFC_FINANCE_DATA_ERROR> {
}

export const saveIfcFinanceData: (data: any, isLastApplicationStep?: boolean) => SaveIfcFinanceDataAction = (ifcApplicationData: any, isLastApplicationStep: boolean = false) => ({
    type: CheckoutActionTypes.SAVE_IFC_FINANCE_DATA,
    ifcApplicationData,
    isLastApplicationStep
});
saveIfcFinanceData[ACTION_CREATOR_NAME] = 'saveIfcFinanceData';

export type SaveIfcFinanceDataFunc = (...args: Parameters<typeof saveIfcFinanceData>) => void;

export function* saveIfcFinanceDataSaga({ ifcApplicationData, isLastApplicationStep }: SaveIfcFinanceDataAction): BasketSagaReturnType {
    yield put<CheckoutActions>({
        type: CheckoutActionTypes.SAVE_IFC_FINANCE_DATA_START
    });

    try {
        let state: AppState = yield select();

        let updatedIfcApplicationData = { ...state.checkoutState.ifcApplicationData, ...ifcApplicationData };

        yield put<CheckoutActions>({
            type: CheckoutActionTypes.SAVE_IFC_FINANCE_DATA_SUCCESS,
            ifcApplicationData: updatedIfcApplicationData,
            ifcApplicationFilledByCustomer: isLastApplicationStep
        });

        return true;
    } catch (error) {
        yield put<CheckoutActions>({
            type: CheckoutActionTypes.SAVE_IFC_FINANCE_DATA_ERROR,
            error: errorToBasketErrorModel(error, 'saveIfcFinanceDataSaga')
        });

        return false;
    }
}